import {goToRoute} from 'app/utils/link_helper';
import React, {Component, ReactNode} from 'react';
import Items from 'app/components/shop/Items';
import {ShopsStoreProps} from 'app/store/ShopStore';
import {inject, observer} from 'mobx-react';
import I18n from 'app/i18n';

@inject('shopStore')
@observer
export default class ProductItems extends Component<ShopsStoreProps> {
    componentDidMount = (): void => {
        if (this.props.shopStore.data.product_items.length === 0) {
            goToRoute('/shop');
        }
    };

    render(): ReactNode {
        const {data: {user: {points}, product_items}} = this.props.shopStore;
        const title = `${I18n.t('menu_links.shop')} - ${I18n.t('menu_links.products')}`;
        return <div className="tabs__content">
            <div className="tabs__content-item">
                <h1 className="visually-hidden-title">{title}</h1>
                <Items items={product_items} points={points}/>
            </div>
        </div>;
    }
}
